var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "totale-preventivo" },
    [
      _c(
        "RightPanel",
        {
          attrs: { title: "Preventivo" },
          scopedSlots: _vm._u([
            {
              key: "footer",
              fn: function() {
                return [
                  _c("div", [
                    _c("div", { staticClass: "w-100 text-center mt-2 mb-3" }, [
                      _c("b", [_vm._v("Riepilogo dati")])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "d-flex justify-content-between mb-3" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "text-center",
                            staticStyle: { width: "33%" }
                          },
                          [
                            _c("img", {
                              staticClass: "icon-totale-preventivo mb-1",
                              attrs: {
                                src: require("../../../assets/images/svg/blue/icone_altre-date.svg"),
                                height: "24px"
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "small",
                              {
                                staticClass: "text-uppercase d-block nowrap",
                                staticStyle: { height: "13px" }
                              },
                              [_vm._v(_vm._s(_vm.andataFormatted))]
                            ),
                            _vm._v(" "),
                            _c(
                              "small",
                              {
                                staticClass: "text-uppercase d-block nowrap",
                                staticStyle: { height: "13px" }
                              },
                              [_vm._v(_vm._s(_vm.ritornoFormatted))]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "text-center",
                            staticStyle: { width: "34%" }
                          },
                          [
                            _c("img", {
                              staticClass: "icon-totale-preventivo mb-1",
                              attrs: {
                                src: require("../../../assets/images/svg/blue/icone_volo.svg"),
                                height: "24px"
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "small",
                              {
                                staticClass: "d-block font-weight-bold",
                                staticStyle: { height: "13px" }
                              },
                              [_vm._v("Partenza da")]
                            ),
                            _vm._v(" "),
                            _c(
                              "small",
                              {
                                staticClass: "d-block",
                                staticStyle: { height: "13px" }
                              },
                              [_vm._v(_vm._s(_vm.aereoporto))]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "text-center",
                            staticStyle: { width: "33%" }
                          },
                          [
                            _c("img", {
                              staticClass: "icon-totale-preventivo mb-1",
                              attrs: {
                                src: require("../../../assets/images/svg/blue/icone_notti.svg"),
                                height: "24px"
                              }
                            }),
                            _vm._v(" "),
                            _c("div", [
                              _c("b", [_vm._v(_vm._s(_vm.nights))]),
                              _c("small", { staticClass: "ml-1" }, [
                                _vm._v(
                                  _vm._s(_vm.nights === 1 ? "notte" : "notti")
                                )
                              ])
                            ])
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "d-flex justify-content-between mb-3" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "text-center",
                            staticStyle: { width: "33%" }
                          },
                          [
                            _c("img", {
                              staticClass: "icon-totale-preventivo mb-1",
                              attrs: {
                                src: require("../../../assets/images/svg/blue/icone_passeggeri.svg"),
                                height: "24px"
                              }
                            }),
                            _vm._v(" "),
                            _c("small", { staticClass: "d-block" }, [
                              _vm._v(_vm._s(_vm.camere))
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "text-center",
                            staticStyle: { width: "34%" }
                          },
                          [
                            _c("img", {
                              staticClass: "icon-totale-preventivo mb-1",
                              attrs: {
                                src: require("../../../assets/images/svg/blue/icone_volo.svg"),
                                height: "24px"
                              }
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "d-block" }, [
                              _c("b", [_vm._v(_vm._s(_vm.flights))]),
                              _c("small", { staticClass: "ml-1" }, [
                                _vm._v(
                                  _vm._s(_vm.flights === 1 ? "volo" : "voli")
                                )
                              ])
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "text-center",
                            staticStyle: { width: "33%" }
                          },
                          [
                            _c("img", {
                              staticClass: "icon-totale-preventivo mb-1",
                              attrs: {
                                src: require("../../../assets/images/svg/blue/icone_attivita.svg"),
                                height: "24px"
                              }
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "d-block" }, [
                              _c("b", [_vm._v(_vm._s(_vm.services))]),
                              _c("small", { staticClass: "ml-1" }, [
                                _vm._v("attività")
                              ])
                            ])
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _vm.hasArrivalServiceTransfer()
                      ? _c("div", { staticClass: "text-center mb-3" }, [
                          _c("img", {
                            staticClass: "icon-alert-night-transfer",
                            attrs: {
                              src: require("../../../assets/images/svg/red/icone_alert.svg"),
                              height: "18px"
                            }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "d-block" }, [
                            _c("b", [_vm._v("1")]),
                            _c("small", { staticClass: "ml-1" }, [
                              _vm._v("notte transfer")
                            ])
                          ])
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("modal-change-search", {
                    ref: "modalChangeSearch",
                    on: { change: _vm.onClickModify }
                  })
                ]
              },
              proxy: true
            }
          ])
        },
        [
          [
            _c("h6", [_vm._v("Per persona")]),
            _vm._v(" "),
            _c("div", { staticClass: "d-flex justify-content-between" }, [
              _c("h1", { staticClass: "currency" }, [
                _vm._v(_vm._s(_vm.totalePerPersona) + " €")
              ]),
              _vm._v(" "),
              _c("p", [
                _c("span", [_vm._v("Totale")]),
                _c("b", [_vm._v(_vm._s(_vm.totale) + " €")])
              ])
            ])
          ]
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-10959116", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10959116","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/front/components/widgets/common/TotalePreventivo.vue
// module id = null
// module chunks = 